import {
	Control,
	Controller,
	UseFormReturn,
	useFieldArray,
} from "react-hook-form";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDown,
	IEnhancedDropDownItem,
	ITest,
	RHookFormNumberField,
	RHookFormTextField,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import ClearIcon from "@mui/icons-material/Clear";
import Grid from "@mui/material/Grid";
import { IRL1SlipRequestPayload } from "../../../../models/rl1Slip/IRL1SlipRequestPayload";
import PlusOneIcon from "@mui/icons-material/PlusOne";

export interface IOtherInformationSetupFieldsPanel extends ITest {
	formMethods: UseFormReturn<any, IRL1SlipRequestPayload>;
	otherInformationList: any;
	isLoading: boolean;
	selectedOtherInformation: boolean;
	// globalVariablesData: any;
	oiInEdit: boolean;
}

const FIELD_NAME = "comparison";

interface EnhancedDDLFieldProps extends ITest {
	name: any;
	control: Control<any>;
	items: IEnhancedDropDownItem[];
	flexFieldsList: IEnhancedDropDownItem[];
	isLoading?: boolean;
	label: string;
	selectedOtherInformation: boolean;
	oiInEdit: boolean;
	formMethods: any;
	onValueChange: (value: any) => void;
	selectedOiInEdit: boolean;
}
let selectedItems: any = [];
export let selectedoi: any = [];
export let FilteredSelectedOtherInfoRL1: any = [];

const EnhancedDropDownRHF: FC<EnhancedDDLFieldProps> = ({
	name,
	control,
	items,
	isLoading = false,
	label,
	testId,
	selectedOtherInformation,
	formMethods,
	flexFieldsList,
	onValueChange,
	oiInEdit,
	selectedOiInEdit,
}) => {
	const fieldTestId = `${testId}-name`;

	// alert(selectedOtherInformation)
	if (selectedOtherInformation !== false) {
		selectedItems = [];
		onValueChange(flexFieldsList);
	}
	const getValue = formMethods.getValues("comparison");

	const defualtOI = [{ amount: 0, code: "", label: "" }];
	if (getValue && getValue[0].code === defualtOI[0].code) {

		selectedItems = [];
		onValueChange(flexFieldsList);
	} else {
		const codes = getValue && getValue.map((item: any) => item.code);

		selectedItems = codes;
	}
	return (
		<Controller
			render={({ field, fieldState: { error } }) => {
				const { ref, value, onChange, ...rest } = field;

				//
				const getAvailableOI = formMethods.getValues("comparison");

				if (selectedOiInEdit && getAvailableOI && getAvailableOI[0].code !== defualtOI[0].code) {

					selectedoi = getAvailableOI;
				} else if (
					selectedOiInEdit &&
					getAvailableOI && getAvailableOI && getAvailableOI[0].code === defualtOI[0].code
				) {

					selectedoi = [];
				} else if (getAvailableOI && getAvailableOI[0].code === defualtOI[0].code) {

					selectedoi = [];
				}
				const transformedValue = selectedoi.map((item: any) => {
					return {
						code: item.value || item.code,
						label: item.label,
						amount: item.amount,
					};
				});


				// const filteredSelectedoi = transformedValue.filter((item:any) => {
				//   const valueItem = getAvailableOI.find((value:any) => value.code === item.code);
				//   return valueItem;
				// })
				const latestValues = transformedValue.reduce((acc: any, item: any) => {
					acc[item.code] = item.label; // Overwrite with the latest value for each code
					return acc;
				}, {});
				const filteredSelectedoi = getAvailableOI && getAvailableOI
					.filter((item: any) => item.code !== "null" && item.code !== "") // Ignore items where code is "null"
					.map((item: any) => ({
						code: item.code,
						label: latestValues[item.code] || item.label,
					}));
				FilteredSelectedOtherInfoRL1 = filteredSelectedoi;


				return (
					<EnhancedDropDown
						{...rest}
						items={items}
						selectedItem={value}
						showEmpty={false}
						testId={fieldTestId}
						selectName={name}
						isDisabled={false}
						isLoading={isLoading}
						onChangeHandler={(val: { value: IEnhancedDropDownItem }) => {
							onChange(val.value);
							let value = val.value;
							selectedItems.push(value);
							selectedoi.push(val);
						}}
						{...(error && { helperText: error.message })}
					/>
				);
			}}
			name={name}
			control={control}
		/>
	);
};

export const OtherInformationSetupFieldsPanel: FC<
	IOtherInformationSetupFieldsPanel
> = ({
	formMethods,
	otherInformationList: flexFieldsList,
	isLoading,
	testId,
	selectedOtherInformation,
	oiInEdit,
}) => {
		const { fields, append, remove } = useFieldArray({
			control: formMethods.control,
			name: FIELD_NAME,
		});

		// useEffect(() => {
		//   append([
		//     // { operator: "", field: 0 },
		//     // { operator: "", field: 0 },
		//     // { operator: "", field: 0 },
		//     // { operator: "", field: 0 },
		//     { amount: 0, code: '', label:'Other Information'},
		//   ]);
		// }, []);


		const [additionalSelects, setAdditionalSelects] =
			useState<IEnhancedDropDownItem[]>(flexFieldsList);
		const [selectedOiInEdit, setSelectedOiInEdit] = useState(false);

		useEffect(() => {
			setSelectedOiInEdit(oiInEdit);
		}, [oiInEdit]);


		const onAddClicked = () => {
			append({ amount: null, code: "null", label: "Empty Field" });


			if (flexFieldsList) {
				if (selectedItems !== "") {
					// Create a new array of items excluding the currently selected one
					const filteredItems = flexFieldsList.filter(
						(item: any) => !selectedItems.includes(item.value)
					);

					// Add the new array to the state to create a new select
					setAdditionalSelects(filteredItems);

				}
			}
			if (selectedOiInEdit) {
				setSelectedOiInEdit(false);
			}
		};

		return (
			<>
				{fields &&
					fields.map((item, index) => {
						return (
							<Grid container columnSpacing={1} key={item.id} alignItems="center">
								<Grid size={{ xs: 7.3 }} sx={{ pt: 1 }}>
									<EnhancedDropDownRHF
										name={`${FIELD_NAME}.${index}.code`}
										label="Field"
										items={additionalSelects}
										flexFieldsList={flexFieldsList}
										isLoading={isLoading}
										control={formMethods.control}
										testId={`${testId}-${index}-code`}
										selectedOtherInformation={selectedOtherInformation}
										oiInEdit={oiInEdit}
										selectedOiInEdit={selectedOiInEdit}
										formMethods={formMethods}
										onValueChange={(newValue: any) =>
											setAdditionalSelects(newValue)
										}
									/>
								</Grid>
								{/* <Grid size={{ xs: 1}}></Grid> */}
								<Grid size={{ xs: 3.4 }} sx={{ "& .p-inputnumber-input": { width: "6rem!important" } }}>
									<RHookFormNumberField
										id={`${FIELD_NAME}.${index}.amount`}
										testId={`${testId}-1`}
									/>
								</Grid>
								<Grid size={{ xs: 1.3 }} sx={{ "& .enhanced-button": { paddingLeft: "8.5px!important" } }}>
									{fields.length !== 1 && index > fields.length - 2 && (
										<EnhancedButtonPrimeReact
											// icon="pi pi-trash"
											icon="pi pi-times"
											onClickHandler={() => remove(index)}
											style={{ marginBottom: "34px", marginLeft: "5px" }}
											severity={EnhancedButtonPrimeReactSeverity.Danger}
											className="p-button-rounded p-button-text w-2rem h-2rem"
											rounded
										/>
									)}
								</Grid>
							</Grid>
						);
					})}
				<Box sx={{ display: "flex", justifyContent: "left" }}>
					<Box>
						<EnhancedButtonPrimeReact
							onClickHandler={onAddClicked}
							label="+1&nbsp;&nbsp;Add More"
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
						/>
					</Box>
				</Box>
			</>
		);
	};
